import { render, staticRenderFns } from "./CashAdvancesDetails.vue?vue&type=template&id=0395db73"
import script from "./CashAdvancesDetails.vue?vue&type=script&lang=js"
export * from "./CashAdvancesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports